// Experience.jsx
import { OrbitControls } from '@react-three/drei';
import Lights from './Lights.jsx';
import { Level } from './Level.jsx';
import { Physics } from '@react-three/rapier';
import { Perf } from 'r3f-perf';
import Player from './Player.jsx';
import useGame from './stores/useGame.js';

export default function Experience() {
  const blocksCount = useGame((state) => state.blocksCount);
  const blockSeed = useGame((state) => state.blockSeed);

  return (
    <>
      <color args={['#bdedfc']} attach="background" />
      <Perf position="top-left" />
      <OrbitControls makeDefault />

      <Physics debug={false}>
        <Lights />
        <Level count={blocksCount} seed={blockSeed} />
        <Player />
      </Physics>
    </>
  );
}
